import { CalendarDays, ChevronDown, ChevronUp } from 'lucide-react'
import { useState } from 'react'

import { Button } from '@/shared/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/shared/components/ui/dropdown-menu'

const QUOTE_PERIOD_OPTIONS = [
  { value: 'all', label: 'All Time' },
  { value: 'today', label: 'Today' },
  { value: 'this_week', label: 'This Week' },
  { value: 'this_month', label: 'This Month' },
  { value: 'previous_month', label: 'Previous Month' },
  { value: 'this_quarter', label: 'This Quarter' },
  { value: 'previous_quarter', label: 'Previous Quarter' },
  { value: 'this_year', label: 'This Year' },
  { value: 'custom', label: 'Custom Date Range' },
]

export default function QuoteFilters({
  total = 0,
  filtered = 0,
  period = 'all',
  onPeriodChange,
  startDate = '',
  endDate = '',
  onStartDateChange,
  onEndDateChange,
  onApplyCustomDate,
}) {
  const [open, setOpen] = useState(false)
  const selectedLabel =
    QUOTE_PERIOD_OPTIONS.find((option) => option.value === period)?.label ||
    'All Time'

  const handlePeriodSelect = (value) => {
    onPeriodChange?.(value)
  }

  return (
    <div className="flex w-full items-center justify-between gap-4">
      {/* Left side */}
      <div className="flex items-center gap-3">
        {/* Total */}
        <span className="whitespace-nowrap text-sm text-slate-600">
          {filtered} of {total}
        </span>

        {/* Period dropdown */}
        <DropdownMenu open={open} onOpenChange={setOpen}>
          <DropdownMenuTrigger asChild>
            <Button variant="outline" className="h-10 gap-2 rounded-xl px-4">
              {selectedLabel}
              {open ? (
                <ChevronUp className="size-4" />
              ) : (
                <ChevronDown className="size-4" />
              )}
            </Button>
          </DropdownMenuTrigger>

          <DropdownMenuContent align="end">
            {QUOTE_PERIOD_OPTIONS.map((option) => (
              <DropdownMenuItem
                key={option.value}
                onSelect={() => handlePeriodSelect(option.value)}
              >
                {option.label}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>

        {/* Custom date controls */}
        {period === 'custom' && (
          <>
            {/* Start Date */}
            <div className="relative">
              <CalendarDays className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-slate-400" />

              <input
                type="date"
                value={startDate}
                onChange={(event) => onStartDateChange?.(event.target.value)}
                className="h-10 w-[150px] rounded-xl border bg-white pl-9 pr-3 text-sm text-slate-700 outline-none transition focus:ring-2"
              />
            </div>

            {/* End Date */}
            <div className="relative">
              <CalendarDays className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-slate-400" />

              <input
                type="date"
                value={endDate}
                min={startDate || undefined}
                onChange={(event) => onEndDateChange?.(event.target.value)}
                className="h-10 w-[150px] rounded-xl border bg-white pl-9 pr-3 text-sm text-slate-700 outline-none transition focus:ring-2"
              />
            </div>

            {/* Apply */}
            <Button
              type="button"
              className="h-10 rounded-xl px-5 bg-[#0F172A]"
              disabled={!startDate || !endDate}
              onClick={() => onApplyCustomDate?.()}
            >
              Apply
            </Button>
          </>
        )}
      </div>
    </div>
  )
}
